import {hitGoogleTagManager} from "./hit_google_tag_manager";

type NotificationStep = "open" | "sign_up";
export const gtmNotificationsSignup = (notificationStep: NotificationStep) => {
    hitGoogleTagManager({event: "notification_sign_up", notification_step: notificationStep});
};
import {hitGoogleTagManager} from "./hit_google_tag_manager";

type NotificationStep = "open" | "sign_up";
export const gtmNotificationsSignup = (notificationStep: NotificationStep) => {
    hitGoogleTagManager({event: "notification_sign_up", notification_step: notificationStep});
};
